<template>
    <v-container

    >
    <v-app-bar
      absolute
      color="#FFFFFF"
      prominent
      app
      height="40"
      flat
    >
      <template v-slot:img="{ props }">
          <v-img
            v-bind="props"
            gradient="to top right,  rgba(25,32,72,.7), #60050B"
          ></v-img>       
      </template>
      <div class="logo">
        <router-link to="/">
          <v-img
            contain
            width="240"
            height="80"
            class="mt-1"
            src="@/assets/juba2.jpg"
          >
          </v-img>
        </router-link>
      </div>

     

      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-spacer></v-spacer>
        <div
            v-for="tab in juba.menu"
            :key="tab.id"
        >

            <v-menu  
                bottom
                right
                offset-y
                class="dropdown-menu"
                active-class="test"
                open-on-hover
                v-if="tab.subpages"
                
                >
                <template v-slot:activator="{ on }">
                    <v-btn
                        text
                        class="align-self-center mr-4 primary--text"
                        v-on="on"
                    >
                    <strong>
                        {{tab.label}}
                    </strong>
                    <v-icon right>mdi-menu-down</v-icon>
                    </v-btn>
                </template>

                <v-list class="v-list__tile" color="primary" dark active-class="white" >
                    <v-list-item
                    v-for="tab in tab.subpages"
                    :key="tab.label"
                    :to="tab.url"
                    color="white"
                
                    >
                    <strong>
                        {{ tab.label }}
                    </strong>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn
                v-else
                text
                color="primary"
                :to="tab.url"
            >

            <strong>
                {{tab.label}}
            </strong>
            </v-btn>
        </div>
        <div>
        <v-btn
            text
            color="primary"  
            v-if="!isLogedIn" 
            to="/login"
          >
          <strong>
              login
          </strong>
        </v-btn>
        </div>
            <div
        v-if="isLogedIn"
    >
          <v-menu offset-y open-on-hover color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn
                dark
                icon
                v-on="on"
              >
                <v-icon color="primary">mdi-account</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                @click="userActions(item.action)"
                color="secondary"
              >
               <strong class="logout">{{ item.title }}</strong> 
              </v-list-item>
            </v-list>
          </v-menu>
    </div>

      </template>
    </v-app-bar>
</v-container>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";
  export default {
    name: "DesktopHeader",
    props: {
        juba: Object
    },

    data: () => ({
      items: [
 
        { title: 'Upload Picture Menu',
          action: 1
         },
         { title: 'Update Picture Menu',
          action: 2},

          { title: 'Upload Text Menu',
          action: 3},
          { title: 'Update Text Menu',
            action: 4},

         { title: 'Logout',
          action: 5
         },
      ],
    }),
    methods: {
      ...mapActions(['logout']),
      userActions(action) {
        switch(action) {
          case 1: 
            this.$router.push('/upload')
            break;
          case 2:
            this.$router.push('/Dashboard')
            break;
          case 3:
            this.$router.push('/upload_text')
            break;
          case 4:
            this.$router.push('/update_text')
            break;
          case 5:
              this.logout();
              break;
          default:
            console.log("something went wrong! refresh the page")
        }

      }, 

    },
    computed: {
        ...mapGetters(['isLogedIn']),
        image() {
          return "/assets/logo.jpg"
        }
    }
  }
  
</script>
<style scoped>
    .toolbartitle{
        font-style: italic;
        font-size: 50px;
        text-align: center;
        font-family:Arial, Helvetica, sans-serif;
        color: rgb(77, 8, 11);
        font-weight: 800;
        
    }
    .test{
        color: #60050B
    }
    .logo{
      width: 410px;
      height: 15px;
    }
</style>